/**
 * Whether SEN investigating (KI) fields match the last loaded server values.
 * Both note and checked must match; matching only one must not hide edits.
 */
export const isSenInvestigatingUnchanged = (saved, current) =>
    saved?.note === current?.note && saved?.isChecked === current?.isChecked;
